export enum AuthTabs {
  LOGIN = 'login',
  REGISTER = 'register',
}
